import { Application } from '@hotwired/stimulus';

const application = Application.start();

// Auto-register Stimulus controllers defined alongside ViewComponents under
// app/components/ui/<component>_component/<component>_component_controller.js.
// Identifier convention: strip the `_controller.js` suffix and convert
// underscores to hyphens. E.g. `timer_button_component_controller.js` ->
// `timer-button-component`.
const context = require.context( // eslint-disable-line no-undef
  '../../components/ui',
  true,
  /_controller\.js$/,
);

// App-level controllers that belong to a page rather than to a kit component live here,
// under the same naming convention.
const appContext = require.context('.', false, /_controller\.js$/); // eslint-disable-line no-undef

const register = (ctx) => {
  ctx.keys().forEach((key) => {
    const mod = ctx(key);
    const filename = key.split('/').pop();
    const identifier = filename
      .replace(/_controller\.js$/, '')
      .replace(/_/g, '-');

    if (mod && mod.default) {
      application.register(identifier, mod.default);
    }
  });
};

register(context);
register(appContext);

export default application;
